import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCourseAvailable } from 'app/actions/CourseAvailableActions';
import { getCourseAvailable } from 'app/reducers';
import isEmpty from 'app/utils/IsEmpty';

export default function CourseAvailableContainer(props){

    const {
        courseAvailables
    } = useSelector(state => state.CourseAvailable)

    const dispatch = useDispatch();
    
    useEffect(() => {
        if (isEmpty(courseAvailables)) fetchCourseAvailableAction();
    }, []);

    const fetchCourseAvailableAction = () => dispatch(fetchCourseAvailable(props.id));

    return (props.children({ courseAvailables }));
}